var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportDynamicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14454 0.318617C8.78228 0.318617 8.48828 0.612617 8.48828 0.974867V11.5107C8.48828 11.873 8.78228 12.167 9.14454 12.167C9.50679 12.167 9.80079 11.873 9.80079 11.5107V0.974867C9.80079 0.612617 9.50679 0.318617 9.14454 0.318617Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14474 0.319078C8.97061 0.319078 8.80261 0.388203 8.68011 0.512453L6.12858 3.07358C5.87308 3.33083 5.87395 3.74645 6.13033 4.00195C6.38758 4.25745 6.80234 4.25745 7.05784 4.0002L9.14474 1.90458L11.2316 4.0002C11.4871 4.25745 11.9019 4.25745 12.1591 4.00195C12.4155 3.74645 12.4164 3.33083 12.1609 3.07358L9.60937 0.512453C9.48686 0.388203 9.31886 0.319078 9.14474 0.319078Z",
    fill: "current"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4226_19922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 18,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.394531 18.0264H17.8945V6.00037H0.394531V18.0264Z",
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4226_19922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0228 18.026H4.2752C2.1358 18.026 0.394531 16.2856 0.394531 14.1454V9.871C0.394531 7.736 2.13142 6 4.26732 6H5.0907C5.45296 6 5.74696 6.294 5.74696 6.65625C5.74696 7.0185 5.45296 7.3125 5.0907 7.3125H4.26732C2.85506 7.3125 1.70704 8.45963 1.70704 9.871V14.1454C1.70704 15.562 2.85856 16.7135 4.2752 16.7135H14.0228C15.4333 16.7135 16.5822 15.5646 16.5822 14.1541V9.88063C16.5822 8.464 15.4298 7.3125 14.0149 7.3125H13.1994C12.8372 7.3125 12.5432 7.0185 12.5432 6.65625C12.5432 6.294 12.8372 6 13.1994 6H14.0149C16.1543 6 17.8947 7.74125 17.8947 9.88063V14.1541C17.8947 16.2891 16.1569 18.026 14.0228 18.026Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDynamicIcon);
export default __webpack_public_path__ + "static/media/exportDynamicIcon.9c774ca215bd47faec1d510aacd0fdac.svg";
export { ForwardRef as ReactComponent };